import {questionStatus} from 'shared/forecast/question'

export type StatusMd = {
  label?: string
  verb?: string
  desc: string
  color: string
  /** state of the forecasting tools when the question has this status */
  forecast?: {
    /**  */
    visible?: boolean
    readonly?: boolean
  }
  displayOrder?: number
  /** the status is one where there will be no more forecasting */
  ended?: boolean
  active?: boolean
  defaultNextStatus?: string
  hide?: boolean
}

export type QuestionStatus = (typeof questionStatus)[number]
export const questionStatusMd: Record<QuestionStatus, StatusMd> = {
  draft: {
    desc: 'Not yet ready to be reviewed. By default hidden',
    color: 'slate',
    displayOrder: 0,
    defaultNextStatus: 'question-review',
    active: true
  },
  'draft-admin': {
    desc: 'Not yet ready to be reviewed. Only visible to admins',
    color: 'slate',
    displayOrder: 9,
    hide: true,
    active: true
  },
  'question-review': {
    verb: 'Review',
    label: 'Review',
    desc: 'Review of question (including initial forecasting) before conditional forecasts are generated.',
    color: 'blue',
    forecast: {visible: true},
    displayOrder: 3,
    defaultNextStatus: 'conditional-generation',
    active: true
  },
  'conditional-generation': {
    label: 'Question Generation',
    desc: 'Soliciting causes, consequences and related sub-questions from forecasters. Forecasts can be made, but likely will need to be revised.',
    color: 'indigo',
    displayOrder: 2,
    defaultNextStatus: 'forecasting',
    active: true
  },
  forecasting: {
    label: 'Forecasting',
    verb: 'Forecast',
    desc: 'Question and conditionals (causes and consequences) are open for forecasting',
    color: 'emerald',
    forecast: {visible: true},
    displayOrder: 1,
    defaultNextStatus: 'complete',
    active: true
  },
  paused: {
    desc: 'Was open, but not temporarily not ready to be forecasted',
    color: 'rose',
    forecast: {visible: true},
    displayOrder: 6
  },
  complete: {
    desc: 'No longer needs updated forecasts',
    color: 'orange',
    forecast: {visible: true, readonly: true},
    ended: true,
    displayOrder: 5
  },
  closed: {
    desc: 'Closed without expectation of being resolved',
    color: 'stone',
    forecast: {visible: true, readonly: true},
    ended: true,
    displayOrder: 8
  },
  resolved: {
    desc: 'The question has been resolved',
    color: 'stone',
    forecast: {visible: true, readonly: true},
    ended: true,
    displayOrder: 7,
    hide: true // resolved is deprecated
  }
}
